import { Component, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCheck, lucideTriangleAlert, lucideX } from '@ng-icons/lucide';
import { BrnDialogClose, BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmDialogFooter, HlmDialogHeader, HlmDialogTitle } from '@spartan-ng/helm/dialog';

@Component({
  selector: 'app-confirm-dialog',
  imports: [NgIcon, HlmButton, HlmDialogHeader, HlmDialogTitle, HlmDialogFooter, BrnDialogClose],
  providers: [provideIcons({ lucideX, lucideCheck, lucideTriangleAlert })],
  templateUrl: './confirm-dialog.component.html',
  host: {
    class: 'flex flex-col gap-4',
  },
})
export class ConfirmDialogComponent {
  readonly dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef);
  readonly #dialogContext = injectBrnDialogContext<{
    titre: string;
    contenu: string;
    messageAlerte?: string;
    confirmBtnText?: string;
  }>();

  protected readonly titre = this.#dialogContext.titre;
  protected readonly contenu = this.#dialogContext.contenu;
  protected readonly messageAlerte = this.#dialogContext.messageAlerte;
  protected readonly confirmText = this.#dialogContext.confirmBtnText ?? 'Valider';

  close(value: boolean): void {
    this.dialogRef.close(value);
  }
}
